export default function isPartiallyinViewport(node) {
  if (!node) return false;
  var el_infos = node.getBoundingClientRect();
  const win_h = window.visualViewport?.height || window.innerHeight;

  // en dessous de l'écran
  if (el_infos.top > win_h) return false;

  // au dessus de l'écran
  if (el_infos.top < -win_h) return false;
  return true;
}
